import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { CoopCreationDateBolt } from "./CoopCreationDateBolt";
export var CoopInfoProfile = function (_a) {
    var level = _a.level, creationTime = _a.creationTime;
    return (React.createElement("div", { className: IdStyles.CoopInfoGraphicContainer + " flex flex--stacked flex--aligned flex--end info-view__container" },
        React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: "flex flex--guts info-view-coop-level " + IdStyles.IconLarge },
            React.createElement("div", { className: "coop-search-level-text" },
                React.createElement(NumberFormat, { className: IdStyles.TextSmallBoldSecondaryOutline, amount: level }))),
        React.createElement("div", { className: "info-view-coop-content inherit-width flex flex--stacked flex--aligned" },
            React.createElement("div", { className: "big-coop-picture big-coop-picture__coop" }),
            React.createElement(CoopCreationDateBolt, { creationTime: creationTime }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopInfoProfile.tsx
// module id = 917
// module chunks = 3